import { useFieldState } from 'informed';
import { TyLifeScore } from './TyLivesScore';
import { TyNumberInput } from '@tymbe/ui-forms';
import { LifeConstants } from '@tymbe/schema/constants/life_constants';
import { ComponentProps } from 'react';

type LivesFormInputType = Omit<
  ComponentProps<typeof TyNumberInput>,
  'max' | 'min'
>;

export const TyLivesFormInput = (props: LivesFormInputType) => {
  const { value } = useFieldState<number>(props.name);

  return (
    <div className="flex flex-row items-center gap-6">
      <TyLifeScore lives={value ?? 0} />
      <div className="w-[148px]">
        <TyNumberInput
          max={LifeConstants.maxLives}
          min={LifeConstants.banThreshold - 1}
          {...props}
        />
      </div>
    </div>
  );
};
